import { Alert, Button } from "@mui/material";
import { IconTypes } from "../../../components/icons.types";

const ProductFieldsAlert = ({ onManageFields, categoryName }) => {
  return (
    <Alert
      severity="info"
      sx={{
        py: 0,
        alignItems: "center",
        "& .MuiAlert-icon": { py: 0, alignSelf: "center" },
        "& .MuiAlert-message": { py: 0.5, alignSelf: "center" },
        "& .MuiAlert-action": {
          py: 0,
          pt: 0,
          mt: 0,
          alignSelf: "center",
          alignItems: "center",
        },
      }}
      action={
        <Button
          color="info"
          size="small"
          startIcon={<IconTypes.Category />}
          onClick={onManageFields}
        >
          Manage Fields
        </Button>
      }
    >
      Need more fields for <b>{categoryName}</b>? Add custom prices, images,
      specs &amp; more.
    </Alert>
  );
};

export default ProductFieldsAlert;
